import EventIcon from '@mui/icons-material/Event'
import { Button, Card, CardActions, CardContent, Grid, Menu, MenuItem, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React, { useContext, useState } from 'react'
import nl2br from 'react-nl2br'
import { AppContext } from '../context/AppContextProvider'

const useStyles = makeStyles(() => ({
    cardMedia: {
        height: '100%',
    },
    cardActions: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    moreInfoLink: {
        flexShrink: 0,
    },
}))

export default function ServiceCard(props) {
    const classes = useStyles()
    const { iframeFixes } = useContext(AppContext)
    const { service, employees, asRooms, onBook, disabled, ...otherProps } = props
    // const [imgErrored, setImgErrored] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)

    // clean up duration
    let [hours, minutes] = service.service_duration ? service.service_duration.split(':') : [0, 0]
    let duration = ''

    hours = parseInt(hours)
    minutes = parseInt(minutes)

    if (hours) {
        duration += hours > 1 ? `${hours} hours` : `${hours} hour`
    }

    if (hours && minutes) {
        duration += ' '
    }

    if (minutes) {
        duration += `${minutes} minutes`
    }

    if (duration) {
        duration = ' for ' + duration
    }

    // figure out book  options
    const bookSpecificEmployee = parseInt(service.book_specific_employee)
    let employeeList = service.book_specific_employee_list.split(',') || []

    // filter-out invalid/deleted employees
    employeeList = employeeList.filter(employeeId => employees.find(employee => employee.id == employeeId))

    function handleBook(employeeId) {
        setAnchorEl(null)
        props.onBook(service.id, employeeId)
    }

    return (
        <Card {...otherProps}>
            {/* <CardMedia
                className={classes.cardMedia}
                title={service.name}
                component="img"
                onError={handleImgError}
                image={service.image_url || window.location.origin + `/product_imgs/${service.upc_code}.png`}
            /> */}
            <CardContent>
                <Typography gutterBottom variant="h5">
                    {service.name}
                </Typography>
                <Grid container justifyContent="space-between" wrap="nowrap">
                    <Typography variant="body2" color="textSecondary">
                        {service.description && nl2br(service.description) || 'No information provided'}
                    </Typography>
                </Grid>
            </CardContent>
            <CardActions className={classes.cardActions}>
                <Typography>
                    ${(Number(service.price)).toFixed(2)}{duration}
                </Typography>
                {disabled &&
                    <Button
                        size="small"
                        color="primary"
                        startIcon={<EventIcon />}
                        disabled={disabled}
                    >
                        {disabled ? 'Registration Required' : 'Book'}
                    </Button>
                }
                {!disabled && onBook && bookSpecificEmployee == 0 &&
                    <Button
                        size="small"
                        color="primary"
                        startIcon={<EventIcon />}
                        onClick={() => { handleBook(null) }}
                    >
                        Book
                    </Button>
                }
                {!disabled && onBook && bookSpecificEmployee > 0 && <>
                    <Button
                        size="small"
                        color="primary"
                        startIcon={<EventIcon />}
                        onClick={(event) => { setAnchorEl(event.currentTarget) }}
                    >
                        Book
                    </Button>
                    <Menu
                        {...iframeFixes.Menu}
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => { setAnchorEl(null) }}
                    >
                        {bookSpecificEmployee == 1 &&
                            <MenuItem onClick={() => { handleBook(null) }}>
                                {asRooms ? 'Any room' : 'Anyone'} (no preference)
                            </MenuItem>
                        }
                        {employeeList.map(employeeId => {
                            const employee = employees.find(employee => employee.id == employeeId)

                            return (
                                <MenuItem key={employee.id} onClick={() => { handleBook(employee.id) }}>
                                    Book {asRooms ? '' : 'with'} {employee.first_name} {employee.last_name}
                                </MenuItem>
                            )
                        })}
                    </Menu>
                </>}
            </CardActions>
        </Card>
    )
}
